var __jsx = React.createElement;
import React from "react";
import { faCheck } from "@fortawesome/pro-solid-svg-icons";
import AwesomeIcon from "../AwesomeIcon";
import DropdownMenu from "../common/DropdownMenu";
import { useTranslation } from "react-i18next";
import { faSortUp, faSortDown } from "@fortawesome/pro-duotone-svg-icons";
import Tooltip from "../common/Tooltip";
import { SORT_BY_MAP, SORT_ORDER_MAP } from "../../types/sort";
var DropdownOption = function DropdownOption(_ref) {
  var selectedType = _ref.selectedType,
    type = _ref.type,
    label = _ref.label,
    icon = _ref.icon;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-3 py-2 px-3"
  }, selectedType === type ? /*#__PURE__*/React.createElement(AwesomeIcon, {
    size: "xs",
    name: faCheck
  }) : /*#__PURE__*/React.createElement("div", {
    className: "w-[11px]"
  }) // Spacer
  , /*#__PURE__*/React.createElement("span", {
    className: "text-md font-medium capitalize"
  }, label), /*#__PURE__*/React.createElement("span", {
    className: "text-md ml-auto"
  }, icon));
};

/**
 * A reusable sort control component with dropdown for column selection and sort order.
 * Supports sorting by different timestamp columns (Last updated, Date created).
 */
var SortControl = function SortControl(_ref2) {
  var selectedType = _ref2.selectedType,
    onTypeChange = _ref2.onTypeChange,
    sortOrder = _ref2.sortOrder,
    onSortChange = _ref2.onSortChange;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var sortByOptions = [{
    name: /*#__PURE__*/React.createElement(DropdownOption, {
      selectedType: selectedType,
      type: SORT_BY_MAP.updated_at,
      label: t("last_updated")
    }),
    label: t("last_updated"),
    type: SORT_BY_MAP.updated_at,
    onClick: function onClick() {
      return onTypeChange(SORT_BY_MAP.updated_at);
    }
  }, {
    name: /*#__PURE__*/React.createElement(DropdownOption, {
      selectedType: selectedType,
      type: SORT_BY_MAP.created_at,
      label: t("date_created")
    }),
    type: SORT_BY_MAP.created_at,
    label: t("date_created"),
    onClick: function onClick() {
      return onTypeChange(SORT_BY_MAP.created_at);
    }
  }];
  var sortOrderOptions = [{
    type: SORT_ORDER_MAP.asc,
    name: /*#__PURE__*/React.createElement(DropdownOption, {
      selectedType: sortOrder || "",
      type: SORT_ORDER_MAP.asc,
      label: t("ascending"),
      icon: /*#__PURE__*/React.createElement(AwesomeIcon, {
        name: faSortUp,
        className: "w-4 h-4"
      })
    }),
    label: t("ascending"),
    onClick: function onClick() {
      return onSortChange(SORT_ORDER_MAP.asc);
    }
  }, {
    type: SORT_ORDER_MAP.desc,
    name: /*#__PURE__*/React.createElement(DropdownOption, {
      selectedType: sortOrder || "",
      type: SORT_ORDER_MAP.desc,
      label: t("descending"),
      icon: /*#__PURE__*/React.createElement(AwesomeIcon, {
        name: faSortDown,
        className: "w-4 h-4"
      })
    }),
    label: t("descending"),
    onClick: function onClick() {
      return onSortChange(SORT_ORDER_MAP.desc);
    }
  }];
  var divider = {
    name: /*#__PURE__*/React.createElement("div", {
      className: "my-2 border-t border-gray-300 dark:border-gray-600"
    }),
    onClick: function onClick() {},
    className: "!p-0 !hover:bg-transparent cursor-default"
  };
  var options = [].concat(sortByOptions, [divider], sortOrderOptions);
  var selectedOption = sortByOptions.find(function (opt) {
    return opt.type === selectedType;
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-2"
  }, /*#__PURE__*/React.createElement(DropdownMenu, {
    options: options,
    menuItemClassName: "!left-0 !right-auto !w-36",
    buttonClassName: "dark:hover:bg-transparent",
    hasCustomControl: true,
    Icon: function Icon() {
      return /*#__PURE__*/React.createElement("span", {
        className: "flex items-center gap-2 text-gray-800 dark:text-gray-500 text-md capitalize"
      }, selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label, /*#__PURE__*/React.createElement(Tooltip, {
        tooltipStyles: "text-sm capitalize rounded-6 py-2 px-3 text-gray-100",
        tooltipBg: "bg-gray-700",
        tooltipText: "".concat(selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label, " - ").concat((sortOrder === SORT_ORDER_MAP.asc ? t("ascending_abbreviation") : t("descending_abbreviation")).toUpperCase())
      }, /*#__PURE__*/React.createElement(AwesomeIcon, {
        name: sortOrder === SORT_ORDER_MAP.asc ? faSortUp : faSortDown,
        className: "w-5 h-5 text-gray-600 dark:text-gray-200"
      })));
    }
  }));
};
export default SortControl;

// Re-export types for convenience

export { SORT_BY_MAP, SORT_ORDER_MAP } from "../../types/sort";